/* Easygreen CBD — Spend £50, Get a Free 3.5g (spend50_free_3_5g)
 * Drives the cart progress bar + gift selector rendered by snippets/eg-free-gift.liquid.
 * Price enforcement is server-side via the automatic Buy X Get Y discount;
 * this script only manages the customer journey and cart hygiene. */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-eg-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.getAttribute('data-eg-config')); } catch (e) { return; }

  var THRESHOLD = cfg.threshold;
  var PROMO = cfg.promo;
  var STR = cfg.strings;
  var busy = false;
  var refreshTimer = null;

  function money(pence) { return '£' + (pence / 100).toFixed(2); }

  function track(name, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', name, props || {}]);
      }
    } catch (e) { /* analytics must never break the cart */ }
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function giftLines(cart) {
    return cart.items.filter(function (i) { return i.properties && i.properties._free_gift === PROMO; });
  }

  function qualifyingSubtotal(cart) {
    return cart.items.reduce(function (sum, i) {
      if (i.properties && i.properties._free_gift) return sum;
      if (cfg.qualifying_products.indexOf(i.product_id) === -1) return sum;
      return sum + i.final_line_price;
    }, 0);
  }

  function postCart(path, payload) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
  }

  function removeAll(gifts) {
    var updates = {};
    gifts.forEach(function (g) { updates[g.key] = 0; });
    return postCart('/cart/update.js', { updates: updates });
  }

  function notify(text) {
    document.querySelectorAll('.eg-gift__note').forEach(function (n) {
      n.textContent = text;
      n.classList.add('is-visible');
      setTimeout(function () { n.classList.remove('is-visible'); }, 7000);
    });
  }

  function render(cart) {
    var gifts = giftLines(cart);
    var sub = qualifyingSubtotal(cart);
    var qualified = sub >= THRESHOLD;

    document.querySelectorAll('[data-eg-gift]').forEach(function (box) {
      if (cart.item_count === 0) { box.hidden = true; return; }
      box.hidden = false;

      var bar = box.querySelector('.eg-gift__bar-fill');
      var msg = box.querySelector('.eg-gift__msg');
      var cta = box.querySelector('.eg-gift__cta');
      var panel = box.querySelector('.eg-gift__panel');

      if (bar) bar.style.width = Math.min(100, Math.round(sub * 100 / THRESHOLD)) + '%';
      box.classList.toggle('eg-gift--qualified', qualified);
      box.classList.toggle('eg-gift--has-gift', gifts.length > 0);

      if (!qualified) {
        msg.textContent = STR.below.replace('[amount]', money(THRESHOLD - sub));
        cta.hidden = true;
        if (panel) panel.classList.remove('is-open');
      } else if (gifts.length === 0) {
        msg.textContent = STR.unlocked;
        cta.hidden = false;
        cta.textContent = STR.cta;
      } else {
        msg.textContent = STR.added.replace('[title]', gifts[0].product_title);
        cta.hidden = false;
        cta.textContent = STR.change;
      }

      box.querySelectorAll('.eg-gift__item').forEach(function (tile) {
        var vid = parseInt(tile.getAttribute('data-variant'), 10);
        tile.classList.toggle('is-selected', gifts.some(function (g) { return g.variant_id === vid; }));
      });
    });

    // The drawer template prints the pre-discount unit price; relabel gift lines
    // as FREE only once Shopify's automatic discount has actually zeroed the line.
    gifts.forEach(function (g) {
      document.querySelectorAll('.js-remove-mini-cart[data-id="' + g.variant_id + '"]').forEach(function (btn) {
        var item = btn.closest('.mini-cart-item');
        if (!item) return;
        var priceSpan = item.querySelector('.mini-cart-meta > span');
        if (g.final_line_price !== 0) return;
        if (priceSpan && priceSpan.textContent.indexOf('FREE') === -1) {
          priceSpan.innerHTML = '<s style="opacity:.6">' + money(g.original_price) + '</s> <strong style="color:#00875f">FREE</strong>';
        }
      });
    });

    armPaymentButtons();
    enforce(cart, gifts, qualified);
  }

  function enforce(cart, gifts, qualified) {
    if (busy) return;

    if (gifts.length && !qualified) {
      busy = true;
      notify(STR.removed);
      removeAll(gifts).then(function () {
        return postCart('/cart/update.js', { attributes: { eg_promo: '' } });
      }).then(function () {
        busy = false;
        track('Free Gift Removed', { promo: PROMO, reason: 'below_threshold' });
        refreshThemeCart();
      }).catch(function () { busy = false; });
      return;
    }

    if (gifts.length > 1 || (gifts.length === 1 && gifts[0].quantity > 1)) {
      busy = true;
      var updates = {};
      gifts.forEach(function (g, ix) { updates[g.key] = ix === 0 ? 1 : 0; });
      postCart('/cart/update.js', { updates: updates }).then(function () {
        busy = false;
        refreshThemeCart();
      }).catch(function () { busy = false; });
    }
  }

  function addGift(variantId) {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      if (qualifyingSubtotal(cart) < THRESHOLD) { busy = false; refresh(); return; }
      var gifts = giftLines(cart);
      var doAdd = function () {
        postCart('/cart/add.js', { id: variantId, quantity: 1, properties: { _free_gift: PROMO } })
          .then(function (r) { if (!r.ok) { throw r; } return r.json(); })
          .then(function () {
            return postCart('/cart/update.js', { attributes: { eg_promo: PROMO } });
          })
          .then(function () {
            busy = false;
            track('Free Gift Added', { promo: PROMO, variant_id: variantId });
            refreshThemeCart();
          })
          .catch(function () {
            busy = false;
            notify(STR.unavailable);
            refresh();
          });
      };
      if (gifts.length) { removeAll(gifts).then(doAdd).catch(function () { busy = false; }); } else { doAdd(); }
    }).catch(function () { busy = false; });
  }

  function refreshThemeCart() {
    if (window.theme && window.theme.miniCart) {
      window.theme.miniCart.generateCart();
      window.theme.miniCart.updateElements();
    }
    if (window.theme && window.theme.cartpage) {
      window.location.reload();
      return;
    }
    refresh();
  }

  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { getCart().then(render); }, 200);
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.eg-gift__cta');
    if (cta) {
      e.preventDefault();
      var panel = cta.closest('[data-eg-gift]').querySelector('.eg-gift__panel');
      var open = panel.classList.toggle('is-open');
      if (open) track('Gift Selector Viewed', { promo: PROMO });
      return;
    }
    var pick = e.target.closest('.eg-gift__pick');
    if (pick) {
      e.preventDefault();
      var vid = parseInt(pick.getAttribute('data-variant'), 10);
      track('Free Gift Selected', { promo: PROMO, variant_id: vid });
      addGift(vid);
    }
  });

  // Promo-safe Buy It Now: intercept dynamic-checkout taps (capture phase runs
  // before Shopify's own handler) and route them through the cart so the gift
  // picker is never skipped. If the AJAX add fails for any reason, fall back to
  // the server-side /cart/add permalink, which lands on the cart page — the
  // picker lives there too, so no route skips it. Branded wallet buttons cannot
  // be intercepted and stay hidden via CSS; .eg-safe re-shows only this one.
  function armPaymentButtons() {
    document.querySelectorAll('.shopify-payment-button').forEach(function (w) {
      w.classList.add('eg-safe');
    });
  }
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('.shopify-payment-button');
    if (!wrap) return;
    var form = wrap.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    var vid = idEl ? parseInt(idEl.value, 10) : NaN;
    if (!vid) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    var fallback = function () {
      window.location.href = '/cart/add?id=' + vid + '&quantity=' + qty + '&return_to=%2Fcart';
    };
    try {
      postCart('/cart/add.js', { id: vid, quantity: qty }).then(function (r) {
        if (!r.ok) { fallback(); return null; }
        return r.json().then(function () {
          track('Buy Now Routed To Cart', { promo: PROMO, variant_id: vid });
          if (window.theme && window.theme.miniCart) {
            window.theme.miniCart.generateCart();
            window.theme.miniCart.updateElements();
          }
          var mini = document.querySelector('.js-mini-cart');
          if (mini) mini.classList.add('active');
          refresh();
        });
      }).catch(fallback);
    } catch (err) { fallback(); }
  }, true);

  // Theme cart ops go through jQuery; our own go through fetch. Watch both.
  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (ev, xhr, settings) {
      if (settings && settings.url && settings.url.indexOf('/cart') !== -1) refresh();
    });
  }
  var _fetch = window.fetch;
  window.fetch = function () {
    var p = _fetch.apply(this, arguments);
    try {
      var u = arguments[0];
      u = (typeof u === 'string') ? u : ((u && u.url) || '');
      if (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1 || u.indexOf('/cart/clear') !== -1) {
        p.then(function () { refresh(); }, function () {});
      }
    } catch (e) { /* noop */ }
    return p;
  };

  // The snippet renders once, hidden, from layout/theme.liquid. Clone it into
  // the cart drawer and the cart page so no core cart template needs editing.
  function mount() {
    var root = document.getElementById('eg-gift-root');
    if (!root || !root.firstElementChild) return;
    var targets = [];
    document.querySelectorAll('.mini-cart-header .js-cart-bottom').forEach(function (t) { targets.push(t); });
    document.querySelectorAll('.cart-right').forEach(function (t) { targets.push(t); });
    if (targets.length === 0) {
      document.querySelectorAll('.mini-cart-content').forEach(function (t) { targets.push(t); });
    }
    targets.forEach(function (t) {
      if (t.querySelector('[data-eg-gift]')) return;
      var clone = root.firstElementChild.cloneNode(true);
      if (t.classList.contains('cart-right')) {
        t.insertBefore(clone, t.firstElementChild);
      } else {
        t.appendChild(clone);
      }
    });
    root.removeAttribute('id');
    root.remove();
  }

  window.addEventListener('focus', refresh);
  function init() { mount(); armPaymentButtons(); refresh(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
